import decode from 'jwt-decode';

import { JWT_COOKIE } from '~/features/cookies/constants';
import { setClientCookie } from '~/features/cookies/utils/set-client-cookie';

export function setJwtCookie(jwt: string) {
  const maybeDecodedJwt = decode(jwt);

  if (isDecodedJwt(maybeDecodedJwt)) {
    setClientCookie(JWT_COOKIE, jwt, new Date(maybeDecodedJwt.exp * 1000));
  }
}

export function isDecodedJwt(value: unknown): value is { exp: number } {
  return value !== null && typeof value === 'object' && 'uid' in value;
}
